// extracted by mini-css-extract-plugin
export var inputContainer = "Input-module--inputContainer--sj98x";
export var inputRoot = "Input-module--inputRoot--VRTCx";
export var labelRoot = "Input-module--labelRoot--FAVVK";